module.exports = __webpack_public_path__ + "img/icon10.e7df4c81.png";